// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  cursor: pointer;
}

.label-info {
  text-transform: capitalize;
}

.icon-toolbar {
  display: inline-block;
  vertical-align: middle;
}

.text-toolbar {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/popup/popover-options/popover-options.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,qBAAA;EACA,sBAAA;AACF;;AAGA;EACE,iBAAA;AAAF","sourcesContent":["ion-item {\n  cursor: pointer;\n}\n\n.label-info {\n  text-transform: capitalize;\n}\n\n.icon-toolbar {\n  display: inline-block;\n  vertical-align: middle;\n  //font-size: 19px;\n}\n\n.text-toolbar {\n  margin-left: 10px;\n  //font-size: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
